"use strict";
// TODO
// import projectConfig from 'salvo.config.js';
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindings = void 0;
// eslint-disable-next-line no-underscore-dangle
exports.bindings = window.__SALVO_TS_BINDINGS;
//# sourceMappingURL=bindings.js.map